var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({model:{value:(_vm.defaultedValue),callback:function ($$v) {_vm.defaultedValue=$$v},expression:"defaultedValue"}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }